<!-- ake第三方车场接入指南 -->
<template>
    <div class="content">
        <ul>
            <li>
                <h2 class="title">Java SDK</h2>
           </li>
        </ul>
        <ul>
            <li>
                <h3>概述</h3>
                <div>
                   这是智慧停车开放平台第三方停车场接入（TCP长连接方式）的Java版本封装开发，由智慧停车开放平台官方提供。
                </div>
            </li>
        </ul>

        <ul>
            <li>
                <h3>安装</h3>
                <div>
                    <h4>maven方式</h4>
                    <div>将下边的依赖条件放到你项目的 maven pom.xml 文件里。</div>
                        <div>
                            <pre>&lt;dependency&gt;
    &lt;groupId&gt;cn.akeparking.api&lt;/groupId&gt;
    &lt;artifactId&gt;ydto-parking-client&lt;/artifactId&gt;
    &lt;version&gt;1.0.3&lt;/version&gt;
&lt;/dependency&gt;</pre>
                        </div>
                    </div>
                <div>
                    <h4>依赖包</h4>
                    <div><a target="_blank" href="https://github.com/netty/netty">netty-all 4.1.19.Final</a>(java网络通信框架)</div>
                    <div><a target="_blank" href="http://www.slf4j.org/">slf4j 1.7.7</a>(Logger)</div>
                    <div><a target="_blank" href="https://github.com/alibaba/fastjson">fastjson 1.1.33</a>(Alibaba JSON Utils)</div>
                    <div>其中 slf4j 可以与 logback, log4j, commons-logging 等日志框架一起工作，可根据你的需要配置使用。</div>
                </div>
            </li>
        </ul>

        <ul>
            <li>
                <h3>使用说明</h3>
                <div>
                <h4>初始化客户端</h4>
                <div>基础初始化</div>
                  <pre>
/**
* @param host 开放平台地址
* @param port 开放平台端口
* @param username 用户名
* @param password 密码
* @param parkSystemName 第三方系统名称
* @param parkSystemVersion 第三方系统版本号
* @param requestHandler 请求处理器
* @param responseHandler 异步响应处理器
*/
Connector.init("open-connector.yidianting.xin", 9192, "test", "123456","XXX车场管理系统","1.0.0",requestHandler,responseHandler);
                  </pre>
                 <div> 增强型初始化(支持了多网自动切换)</div>
                  <pre>
ConnectorConfig config = new ConnectorConfig();
ConnectorAddress mainAddress = new ConnectorAddress(0, "open-connector.yidianting.xin", 9192);
config.setMainAddress(mainAddress);//主地址
ConnectorAddress standbyAddress = new ConnectorAddress(0, "open-connector2.yidianting.xin", 9192);
List&lt;ConnectorAddress&gt; standbyAddressList = new ArrayList&lt;&gt;();
standbyAddressList.add(standbyAddress);//备用地址
config.setStandbyAddressList(standbyAddressList);
config.setUsername("");//用户名
config.setPassword("");//密码
String[] parkCodeArray = {"123"};
config.setParkCodeArray(parkCodeArray);//车场数据，在登录时进行认证
config.setParkSystemName("XXX车场管理系统");//第三方车场管理系统名称
config.setParkSystemVersion("1.0.0");//第三方车场管理系统版本
Connector.init(config,requestHandler,responseHandler);
                </pre>
                </div>
                <div>
                注:请确保客户端只被初始化一次
                <br/>
                多网自动切换说明：<br/>
                主链接的网络通畅时，客户端会自动使用主链路进行通信；当主链路断开时，会自动查找可用的备用链路进行连接，当主链路恢复时，客户端自动切换回主链路
                <br/>
                业务请求处理器：ClientServiceRequestHandler requestHandler<br/>
                处理平台请求客户端的数据，如查费、缴费请求会进入到这个处理器<br/>
                业务响应处理器：ClientAsynResponseHandler responseHandler<br/>
                当客户端异步发送数据到平台时，平台的响应会进入到响应处理器，如果你不使用异步发送数据的话，可传入null进行初始化。
                </div>
                <div>
                <h4>操作说明</h4>
                    <pre>
//查看连接状态
ConnectorStatus connectorStatus = Connector.getConnectorStatus();
boolean isActive = connectorStatus.isActive();//是否已连接
String message = connectorStatus.getMessage();//当前状态说明

//查看当前连接的地址
ConnectorAddress address = Connector.getCurrentAdrress();
address.getId();//你的自定义ID
address.getHost();//地址
address.getPort();//端口
address.getIsMain();//是否是主链接

//刷新配置信息并重新连接（如更改地址或者账号）
Connector.refresh(host, port, account, password);
Connector.refresh(config);
//重新连接
Connector.refresh();

//断开连接(断开不会重连)
Connector.disconnect();
                    </pre>
                </div>
                <div>
                <h4>发送数据</h4>
                    <pre>

//同步发送数据,默认10秒超时
String requestBody = "{\"parkCode\":\"GDFSNHCHARE035\",\"carLicenseNumber\":\"粤SD1234\",\"confidence\":100,\"correctConfidence\":100,\"correctType\":1,\"enterCarCardNumber\":\"\",\"enterCarColor\":0,\"enterCarLicenseColor\":1,\"enterCarLicenseNumber\":\"粤SD1234\",\"enterCarLicenseType\":0,\"enterCarLogo\":0,\"enterCarType\":1,\"enterChannelCode\":\"0001\",\"enterChannelName\":\"进口\",\"enterChargeGroupCode\":\"72\",\"enterCustomVipName\":\"\",\"enterNovipCode\":1,\"enterRecognitionConfidence\":0,\"enterSpeed\":0,\"enterStatisticalArea\":\"0\",\"enterTime\":1541014788000,\"enterType\":1,\"enterVipRule\":\"\",\"enterVipType\":1,\"extendInfo\":{\"inEtcReliable\":\"0\",\"inEtcCarCode\":\"\",\"selfInCode\":\"0840\",\"enterNoVipCodeName\":\"正常\",\"selfInUserUniqCode\":\"\",\"inEtcCode\":\"\"},\"inDriverPosPicId\":\"\",\"inOperatorName\":\"hy\",\"inOperatorTime\":1541014796000,\"isCorrect\":1,\"lastCorrectLicenseNumber\":\"粤SD1234\",\"lastCorrectName\":\"ake\",\"lastCorrectTime\":1541014796000,\"recordType\":0,\"remark\":\"\"}";
try {
    ResponseBody responseBody = Connector.send("upThirdParkCarIn", requestBody);
    if(responseBody.ok()) {//开放平台处理成功
        String data = responseBody.getData();//业务数据
        System.out.println(data);
    }
} catch (ConnectException e) {
    log.error("网络异常",e);
}

//异步发送数据，响应在注册的ClientAsynResponseHandler进行回调
try {
    //msgId:自定义唯一消息ID，会在异步回调回传
    Connector.sendAsyn(msgId, "upThirdParkCarIn", requestBody);
} catch (ConnectException e) {
    log.error("网络异常",e);
}
                    </pre>
                </div>

                <div>
                <h4>接收平台请求/响应</h4>
                    <pre>
//在Connector.init方法进行注册
//请求处理器
ClientServiceRequestHandler requestHandler = new ClientServiceRequestHandler() {
    @Override
    public ResponseBody onMessage(String cmd, String body) throws Exception {
        if("queryCharge"){
            if("queryCharge".equals(cmd)) {//表示查费
                //按照文档返回查费结果 TODO
                return ResponseBody.createSuccessResult(data);
            }
        }
    }
};

//响应处理器，使用异步发送消息将在这里回调,cmd和msgId会与请求时一一对应
ClientAsynResponseHandler responseHandler = new ClientAsynResponseHandler() {
    @Override
    public void onMessage(String cmd, String msgId, ResponseBody responseBody) {
        // to do something
    }
};

                    </pre>
                </div>

            </li>
        </ul>

    </div>
</template>

<script>
export default {
    name: '',
    props: {
        'Pdatas': {
            type: Object,
        }
    },
    data() {
        return {
            respTable: [
                { info1: 'status', info2: '是', info3: 'int', info4: '状态码',info5:'1业务成功,2业务失败,3系统异常,4签名错误,5key错误,6未授权,7请求参数不完整' },
                { info1: 'resultCode', info2: '是', info3: 'int', info4: '业务码',info5:'只有状态码为2时才生效，状态码不为2时业务结果为0;901-系统发生异常,902-远程服务器未响应,903-运营商不存在,904-停车场不存在,905-未找到在场车辆,906-账单不存在,907-账单已同步,908-其它错误'},
                { info1: 'message', info2: '是', info3: 'String', info4: '结果描述' },
                { info1: 'data', info2: '是', info3: 'JSONObject', info4: '返回数据' }
            ],
            othersData: [],
            explainWidth: 200,
        }
    },
}
</script>

<style lang="less" scoped>
.content {
    // font-family: "Helvetica Neue", "Hiragino Sans GB", "Microsoft YaHei", '黑体', Arial, sans-serif;
    font-size: 14px; // background-image: url(../../assets/img/back.png);
    line-height: 1.6;
    color: #1f2d3d;
    h3 {
        margin: 0;
        margin-bottom: 20px;
        font-size: 20px;
        color: #666666;
        letter-spacing: 0;
        border-bottom-width: 1px;
        border-bottom-style: solid;
        border-bottom-color:#e5e5e5;
    }
    h4 {
        margin-bottom: 5px;
        font-size: 16px;
        color: #1b75bb;
    }
    a {
        font-size: 13px;
         color: #337ab7;
    }
    ul {
        padding: 5px 10px;
        li {
            text-align: left;
            >div {
                margin-bottom: 10px;
                //border: 1px red solid;
            }
        }
    }
    .retract {
        padding-left: 15px;
    }


    pre {
        background-color: #f6f6f6;
        font-size: 12px;
    }
}

.subName {
    padding: 15px 0 10px 15px;
    max-width: 90%;
    min-width: 80%;
    color: #333;
}

table {
    display: table;
    max-width: 90%;
    min-width: 80%;
    border-collapse: collapse;
    border-spacing: 0;
    overflow: auto;
    border-bottom: 1px solid #e7e7eb;
}

thead tr:first-child {
    background-color: #f6f8f9;
}

table tr:first-child {
    border: none;
}

table tr {
    border-top: 1px solid #e7e7eb;
}

table th {
    font-weight: 400;
    color: #8d8d8d;
    text-align: left;
    height: 40px;
    padding: 6px 12px;
    white-space: nowrap;
    border: none;
}

table td {
    // height: 35px;
    padding: 15px 12px;
    text-align: justify;
}

</style>


// WEBPACK FOOTER //
// src/components/Doc/thirdParkForAke/sdk/javaSdk.vue